export default (orgArray, targetArray) => {
  //生成下拉列表
  for (var key in orgArray) {
    targetArray.push({
      label: orgArray[key],
      value: key
    });
  }
}


//////////////////
// WEBPACK FOOTER
// ./utils/generateDropDownList.js
// module id = null
// module chunks = 